import {mapToObjectDDL} from "../../common/mapper";
import {v4 as uuidv4} from 'uuid';
import * as R from "ramda";
import moment from "moment";

export const getCategoryType = (type) => {
    switch (type) {
        case "KSU":
            return "KSU_TYPE"
        case "Hadiah":
            return "GIFT_TYPE";
        case "OtherItem":
            return "OTHER_ITEMS_TYPE";
        case "Part":
            return "PART_TYPE";
        default:
            return "KSU_TYPE";
    }
}

export const getDataDetail = (type, data) => {
    switch (type) {
        case "KSU":
            return data.map(item => {
                return {
                    id: uuidv4(),
                    category: mapToObjectDDL(
                        item.dataKSU?.category?.value,
                        item.dataKSU?.category?.key,
                    ),
                    kode: item.dataKSU?.kodeKSU,
                    name: mapToObjectDDL(
                        item.dataKSU?.name,
                        item.dataKSU?.kodeKSU,
                    ),
                    satuan: item.dataKSU?.satuan?.value,
                    jumlah: item.qty,
                    saved: true,
                }
            });
        case "Hadiah":
            return data.map(item => {
                return {
                    id: uuidv4(),
                    category: mapToObjectDDL(
                        item.hadiahDTO?.categoryDTO?.value,
                        item.hadiahDTO?.categoryDTO?.key
                    ),
                    kode: item.hadiahDTO?.kodeHadiah,
                    name: mapToObjectDDL(
                        item.hadiahDTO?.nameHadiah,
                        item.hadiahDTO?.kodeHadiah,
                    ),
                    satuan: item.hadiahDTO?.satuanDTO?.value,
                    jumlah: item.qty,
                    saved: true,
                }
            });
        case "OtherItem":
            return data.map(item => {
                return {
                    id: uuidv4(),
                    category: mapToObjectDDL(
                        item.otherItemResponseDTO?.categoryDTO?.value,
                        item.otherItemResponseDTO?.categoryDTO?.key,
                    ),
                    kode: item.otherItemResponseDTO?.kodeotheritem,
                    name: mapToObjectDDL(
                        item.otherItemResponseDTO?.nameotheritem,
                        item.otherItemResponseDTO?.kodeotheritem,
                    ),
                    satuan: item.otherItemResponseDTO?.satuanDTO?.value,
                    jumlah: item.qty,
                    saved: true,
                }
            });
        case "Part":
            return data.map(item => {
                return {
                    id: uuidv4(),
                    category: mapToObjectDDL(
                        item.part?.partCategory?.value,
                        item.part?.partCategory?.key,
                    ),
                    kode: item.part?.kodePart,
                    name: mapToObjectDDL(
                        item.part?.partName,
                        item.part?.kodePart,
                    ),
                    satuan: item.part?.satuan?.value,
                    jumlah: item.qty,
                    saved: true,
                }
            });
        default:
            return [];
    }
}

export const getValueItemFromArrayDDL = (object, key) => {
    if (object?.[key] === undefined || R.isNil(object[key]) || R.isEmpty(object[key])) {
        return [];
    }

    return Array.isArray(object[key].value)
        ? object[key].value.map((item) => {
            return {kode: item.kode, qty: Number(item.jumlah)};
        })
        : [];
};

export const validateDataItem = (obj) => {
    const fieldsToValidate = ['category', 'name', 'jumlah'];
    const errors = {};

    fieldsToValidate.forEach((field) => {
        const value = obj[field];
        if (value === null || value === undefined || value === '') {
            errors[field] = `${field} cannot be empty or null`;
        }
    });

    const jumlah = obj["jumlah"];
    if (jumlah <= 0) {
        errors['jumlah'] = 'jumlah must be greater than 0';
    }

    return errors;
}

export const filterInitialValue = {
    idPackage: null,
    packageName: null,
    cabangBerlaku: [],
    kodeVariant: null,
    startDate: null,
    endDate: null,
    gracePeriod: null,
    noPeriod: null,
}